<!--产业园出库明细账-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <global-select
          slot="orderType"
          :dropdown-match-select-width="false"
          v-model="queryParams.orderType"
          selectType="selectMultiple"
          requestApi="/inv/invOnhandQuantities/findOrderTypeList"
          :selectItem="{ value: 'selectedValue', label: 'label' }"
          sourseField="res"
        />
        <global-select
          v-decorator="['orgCode', { rules: [{ required: true }] }]"
          :allow-clear="false"
          :default-active-first-option="defaultSelect"
          slot="orgCode"
          :value.sync="queryParams.orgCode"
          selectType="select"
          :selectData="inventOrg"
          :selectItem="{ value: 'realValue', label: 'label' }"
        />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <download-modal :apiFun="apiInvOnhandQuantitiesOutboundExport" ref="download" />
        <a-button
          type="primary"
          @click="handleExport"
        >导出</a-button>
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1000 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.OUTBOUND_DETAILS_LIST, // 表格方案配置唯一值
              }"
        >
          <template slot="dateFormat" slot-scope="data">
            {{ data.text && $moment(data.text).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import {
  apiGetInventoryOutboundDetailsList,
  apiInvOnhandQuantitiesOutboundExport
} from '@/api/report/inventory-outbound-details'
import { generateLsTableResData } from '@/utils/util.js'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import cacheSearch from '@/mixins/cacheSearch'

export default {
  // eslint-disable-next-line
  name: 'Outbound-details', // name要和rms配置菜单路由保存一致(首字母大写)
  components: { DownloadModal },
  mixins: [cacheSearch],
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  data() {
    return {
      apiInvOnhandQuantitiesOutboundExport,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiGetInventoryOutboundDetailsList, false),
        pageCurrent: true
      },
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        wipEntityNameVal: undefined,
        wipEntityNameList: undefined,
        orgCode: undefined,
        orderType: undefined,
        callDocNumber: undefined,
        itemCode: undefined,
        lotName: undefined,
        deliveryDate: undefined,
        jhDate: undefined,
        supplierCode: undefined,
        sublibraryCode: undefined,
        exitOrderNumber: undefined,
        serialNumber: undefined
      },
      // 表格数据
      tableList: [],
      formList: [
        {
          label: '工单号',
          decorator: ['wipEntityNameVal'],
          type: 'input'
        },
        {
          label: '组织编码',
          decorator: ['orgCode'],
          type: 'orgCode'
        },
        {
          label: '单据类型',
          decorator: ['orderType'],
          type: 'orderType'
        },
				{
          label: '叫料单号',
          decorator: ['callDocNumber'],
          type: 'input'
        },
        {
          label: '物料编码',
          decorator: ['itemCode'],
          type: 'input'
        },
        {
          label: '生产批次',
          decorator: ['lotName'],
          type: 'input'
        },
        {
          label: '配送日期',
          type: 'range',
          decorator: ['deliveryDate'],
          disposeFormat: {
            deliveryDateFrom: (change) => {
              return change[0].format('YYYY-MM-DD')
            },
            deliveryDateTo: (change) => {
              return change[1].format('YYYY-MM-DD')
            }
          }
        },
        {
          label: '交货日期',
          type: 'range',
          decorator: ['jhDate'],
          disposeFormat: {
             jhDateFrom: (change) => {
              return change[0].format('YYYY-MM-DD')
            },
             jhDateTo: (change) => {
              return change[1].format('YYYY-MM-DD')
            }
          }
        },
        {
          label: '供应商编码',
          decorator: ['supplierCode'],
          type: 'input'
        },
        {
          label: '子库代码',
          decorator: ['sublibraryCode'],
          type: 'input'
        },
        {
          label: '出库单号',
          decorator: ['exitOrderNumber'],
          type: 'input'
        },
        {
          label: '流水号',
          decorator: ['serialNumber'],
          type: 'input'
        }
      ],
      // 表格字段
      columns: [
        {
          title: '工单号',
          dataIndex: 'wipEntityName',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '组织编码',
          dataIndex: 'orgCode',
          align: 'center',
          width: 120,
          ellipsis: true
        },
        {
          title: '组织名称',
          dataIndex: 'organizationName',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '子库代码',
          dataIndex: 'sublibraryCode',
          align: 'center',
          width: 140,
          ellipsis: true
        },
        {
          title: '子库名称',
          dataIndex: 'sublibrary',
          align: 'center',
          width: 200,
          ellipsis: true
        },
        {
          title: '出库单号',
          dataIndex: 'exitOrderNumber',
          align: 'center',
          width: 120,
          ellipsis: true
        },
        {
          title: '单据类型',
          dataIndex: 'orderType',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '出库单行号',
          dataIndex: 'exitOrderLineNum',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '外部单号',
          dataIndex: 'orderNumber',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '外部单行号',
          dataIndex: 'orderNumberLineNum',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '叫料单号',
          dataIndex: 'callDocNumber',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '拣货单号',
          dataIndex: 'pickOrderNumber',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '配送单号',
          dataIndex: 'deliveryOrderNumber',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '叫料组织',
          dataIndex: 'callOrganizationCode',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '叫料组织名称',
          dataIndex: 'callOrganizationName',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '叫料子库',
          dataIndex: 'callSublibraryCode',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '叫料子库名称',
          dataIndex: 'callSublibrary',
          align: 'center',
          width: 160,
          ellipsis: true
        },
        {
          title: '对方收货单号',
          dataIndex: 'otherReceiptNumber',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          align: 'center',
          width: 160,
          ellipsis: true
        },
        {
          title: '规格描述',
          dataIndex: 'specification',
          align: 'center',
          width: 200,
          ellipsis: true
        },
        {
          title: '货品分类',
          dataIndex: 'goodsType',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '需求数量',
          dataIndex: 'demandQty',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '配送数量',
          dataIndex: 'deliveryQty',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '单位',
          dataIndex: 'unit',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '拣货库位',
          dataIndex: 'pickLocation',
          align: 'center',
          width: 120,
          ellipsis: true
        },
        {
          title: '流水号',
          dataIndex: 'serialNumber',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '内部批次',
          dataIndex: 'insideLotName',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '生产批次',
          dataIndex: 'lotName',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '供应商编码',
          dataIndex: 'supplierCode',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '供应商名称',
          dataIndex: 'supplierName',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '配送人',
          dataIndex: 'deliveryPerson',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '配送时间',
          dataIndex: 'deliveryDate',
					scopedSlots: { customRender: 'dateFormat' },
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '交货日期',
          dataIndex: 'jhDate',
          scopedSlots: { customRender: 'dateFormat' },
          align: 'center',
          width: 150,
          ellipsis: true
        }
      ]
    }
  },
  created() {
    // 处理缓存逻辑
    this.getHistoryCache(
      'refSearchForm',
      'orgCode',
      {
        deliveryDate: ['deliveryDateFrom', 'deliveryDateTo'],
        jhDate: ['jhDateFrom', 'jhDateTo']
      }
    )
  },
  mounted() {
    this.onSearch()
  },
  methods: {
    // 兼容处理excel复制的处理，去掉空格，整合成list
    onChangeCopyFormExcel(params, valField, listField) {
      const listVal = []
      if (params[valField]) {
        const list = params[valField].split(' ')
        list.forEach((v, i) => {
          list[i] = v.replace(/[\n\r\s]+/g, '') // 去掉excel可能存在的空格换行符特殊字符
          if (list[i]) { listVal.push(list[i]) }
        })
      }
      params[listField] = listVal
    },
    // 表单搜索
    onSearch(value = {}) {
      const params = Object.assign({}, this.queryParams, value)
      this.onChangeCopyFormExcel(params, 'wipEntityNameVal', 'wipEntityNameList')
      delete params.searchFormLabel
      this.setSearchCache(params) // 设置缓存
      this.$refs.dataTable.searchParams = params
      this.$refs.dataTable.getData()
    },
    // 新增/修改框事件
    handleOk() {
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParams = {
        wipEntityNameVal: undefined,
        wipEntityNameList: undefined,
        orgCode: this.$refs.dataTable.searchParams.orgCode,
        orderType: undefined,
        callDocNumber: undefined,
        itemCode: undefined,
        lotName: undefined,
        deliveryDate: undefined,
        jhDate: undefined,
        supplierCode: undefined,
        sublibraryCode: undefined,
        exitOrderNumber: undefined,
        serialNumber: undefined
      }
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.refSearchForm.form.setFieldsValue(this.queryParams)
    },
    // 搜索框展开、收起
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    // 导出
    handleExport() {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
    }
  }
}
</script>

<style scoped lang="less"></style>
